import { Directive, ElementRef, ViewContainerRef, ComponentFactoryResolver,
  Input, HostListener, Output , EventEmitter} from '@angular/core';
import { EmojiPickerComponent } from './emoji-picker.component';

@Directive({
  selector: '[appEmojiPicker]'
})
export class EmojiPickerDirective {
  emojiComponent: EmojiPickerComponent;
  originalDisplayProperty: string;
  @Output() someEvent = new EventEmitter();
  @Input() set appEmojiPicker(items: any[]) {
    if (this.emojiComponent) {
      this._element.nativeElement.style.display = this.originalDisplayProperty;
    }
  }
  @HostListener("click", ["$event"])
  public onListenerTriggered(event: any): void {
    let componentRef ;
    if (!this.emojiComponent) {
      let componentFactory = this._componentResolver.resolveComponentFactory(EmojiPickerComponent);
      componentRef = this._viewContainerRef.createComponent(componentFactory);
      this.emojiComponent = componentRef.instance;
      this.emojiComponent.someEvent.subscribe(data => {
        this.someEvent.emit(data);
      });
    }
    this.emojiComponent.isSeen = !this.emojiComponent.isSeen;
  }
  constructor(private _element: ElementRef,
    private _componentResolver: ComponentFactoryResolver,
    private _viewContainerRef: ViewContainerRef, ) { }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/emoji-picker/emoji-picker.directive.ts